import { useAuth } from 'contexts/authContext';
import { Navigate } from 'react-router-dom';
import { reactPaths } from 'root/pathnames';

export const RequireAuth = ({
  requiredRoles,
  children,
}: {
  requiredRoles?: null | { name: string }[];
  children?: JSX.Element;
}) => {
  const { user, hasViewPermission } = useAuth();

  if (!user) {
    return <Navigate replace to={reactPaths.login} />;
  }

  if (!hasViewPermission(requiredRoles)) {
    // TODO: toast for unauthorized users
    return <Navigate replace to={reactPaths.home} />;
  }

  return children || null;
};

export const RequireUnAuth = ({ children }: { children?: JSX.Element }) => {
  const { user } = useAuth();

  if (user) return <Navigate replace to={reactPaths.home} />;

  return children || null;
};

